import type { FieldError as RHFFieldError } from "react-hook-form";

interface FieldErrorProps {
	/** Accept react-hook-form FieldError object or a plain string */
	error?: RHFFieldError | { message?: string };
	message?: string;
	id?: string;
}

const FieldError: React.FC<FieldErrorProps> = ({ error, message, id }) => {
	const text = message || error?.message;
	if (!text) return null;

	return (
		<p
			id={id}
			className="mt-1 font-medium text-(--color-error-500) text-sm animate-in fade-in slide-in-from-top-1 duration-200"
			role="alert"
		>
			{text}
		</p>
	);
};

export default FieldError;
